import { FC } from "react"
import { RtkHookForm } from "@/core/components"
import { Grid, Stack, Typography } from "@mui/material"
import { TgstatBot } from "../interfaces"
import { useUpdateInviteLinkMutation } from "../store"
import {
  DateTimePickerElement,
  SwitchElement,
  TextFieldElement,
} from "react-hook-form-mui"
import { format } from "date-fns"
import { MembersLimit } from "./formFields/membersLimit"

interface IProps {
  inviteLink: TgstatBot.InviteLink
  onSuccess?: () => void
}

interface IFormData extends TgstatBot.UpdateInviteLink {
  invite_link: string
}

export const EditInviteLinkForm: FC<IProps> = ({ inviteLink, onSuccess }) => {
  return (
    <RtkHookForm<
      IFormData,
      TgstatBot.UpdateInviteLinkRes,
      typeof useUpdateInviteLinkMutation
    >
      successMessage="Ссылка обновлена успешно"
      mutationHook={useUpdateInviteLinkMutation}
      formContextParams={{
        defaultValues: {
          invite_link: inviteLink.invite_link,
          name: inviteLink.name || "",
          comment: inviteLink.comment || "",
          expire_date: inviteLink.expire_date,
          member_limit: inviteLink.member_limit,
          creates_join_request: inviteLink.creates_join_request,
        },
      }}
      getSubmitHandlerParams={(data: IFormData) => ({
        pathParams: {
          invite_link: data.invite_link,
        },
        body: {
          name: data.name || undefined,
          comment: data.comment || undefined,
          expire_date: data.expire_date,
          member_limit: data.member_limit,
          creates_join_request: data.creates_join_request,
        },
      })}
      afterSubmit={onSuccess}
      actions={[
        {
          text: "Сохранить",
          type: "submit",
          variant: "contained",
          fullWidth: true,
        },
      ]}
    >
      <Grid container spacing={1}>
        <Grid item xs={12} md={6}>
          <Stack spacing={1}>
            <TextFieldElement<IFormData> name="name" label="Название" />
            <TextFieldElement<IFormData>
              name="comment"
              label="Комментарий"
              multiline
              rows={3}
            />
          </Stack>
        </Grid>
        <Grid item xs={12} md={6}>
          <Stack spacing={1}>
            <SwitchElement<IFormData>
              name="creates_join_request"
              label="Вступление по заявкам"
            />
            <MembersLimit<IFormData> />
            <DateTimePickerElement<IFormData>
              name="expire_date"
              label="Действительна до"
              disablePast
              helperText={
                <Typography variant="caption">
                  Часовой пояс: {format(Date.now(), "OOOO")}
                </Typography>
              }
            />
          </Stack>
        </Grid>
      </Grid>
    </RtkHookForm>
  )
}
